import { render, staticRenderFns } from "./OtherActivitiesOffered.vue?vue&type=template&id=23e1d21d&scoped=true"
import script from "./OtherActivitiesOffered.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherActivitiesOffered.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OtherActivitiesOffered.vue?vue&type=style&index=0&id=23e1d21d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e1d21d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e1d21d')) {
      api.createRecord('23e1d21d', component.options)
    } else {
      api.reload('23e1d21d', component.options)
    }
    module.hot.accept("./OtherActivitiesOffered.vue?vue&type=template&id=23e1d21d&scoped=true", function () {
      api.rerender('23e1d21d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/OtherActivitiesOffered.vue"
export default component.exports